import React, { useEffect, useState } from "react";

import { Modal } from "@material-ui/core";

import { getFoulingTypes } from "api/cipData";

import getLogger from "utils/logger.util";
import { CIPPrediction, FoulingTypes, InsightsStrings, valueStrings } from "constants/constantStrings";

import BadgeLabel from "components/BadgeLabel";
import DupontIconButton from "components/DupontIconButton";

import RecommendationIcon from "assets/Insights/recommendation_Icon.svg";
import CancelIcon from "assets/SvgIcon/Cancel";

import { foulingTypeData } from "./FoulingTypeData";

import "./index.scss";

const Logger = getLogger("FoulingType");

const FoulingType = ({ open, setNoDataErrorMsg, setIsFoulingPopupOpen }) => {
  const [foulingTypes, setFoulingTypes] = useState([]);

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await getFoulingTypes();
        const data = response?.data;
        if (data) {
          const updatedFoulingTypes = [];

          //keeping for dev till data comes correct from back end
          // Object.keys(data).forEach(type => {
          //   if (type.includes("Fouling")) {
          //     data[type] = true;
          //   }
          // });

          Object.keys(data).forEach(type => {
            if (data[type] === true) {
              updatedFoulingTypes.push(foulingTypeData[type]);
            }
          });
          setFoulingTypes(updatedFoulingTypes);
          if (updatedFoulingTypes.length === 0) setNoDataErrorMsg(true);
        }
      } catch (error) {
        Logger.log("Error fetching data:", error);
      }
    }

    fetchData();
  }, []);

  const getFoulingCause = (Key, causeType) => (
    <div className="symptom-text ">
      {causeType}
      <span className="cause-description">{Key}</span>
    </div>
  );
  const handleClose = () => {
    setIsFoulingPopupOpen(false);
  };

  return (
    <div>
      {foulingTypes?.length > 0 && (
        <Modal open={open} closeAfterTransition className="z-index-top">
          <div className="fouling-type-container">
            <div className="flex-between-center">
              <h1>{CIPPrediction.foulingTypes}</h1>
              <DupontIconButton onClick={handleClose} tooltip={valueStrings.close}>
                <CancelIcon />
              </DupontIconButton>
            </div>
            <div className="fouling-card-scroll">
              {foulingTypes.map((item, index) => (
                <div key={index} className="fouling-card">
                  <div className="flex-ai-center ">
                    <div className="symptom-text underline">
                      {FoulingTypes.symptom} {valueStrings.zero}
                      {index + 1}
                    </div>
                    {item?.name && <BadgeLabel badgeText={item.name} />}
                  </div>
                  <div className="flex-between-center ">
                    <h2>
                      {FoulingTypes.permeateFlow} {item?.permeateFlow}
                    </h2>
                    <h2>
                      {FoulingTypes.saltPassage} {item?.saltPassage}
                    </h2>
                    <h2>
                      {FoulingTypes.differentialPressure} {item?.differentialPressure}
                    </h2>
                  </div>
                  <div className="marginBtm5">
                    {item?.directCause && getFoulingCause(item?.directCause, FoulingTypes.directCause)}
                    {item?.indirectCause && getFoulingCause(item?.indirectCause, FoulingTypes.indirectCause)}
                  </div>
                  {item?.recommendation && (
                    <div className="recommendation-container">
                      <div className="margin-top-5">
                        <img src={RecommendationIcon} alt="recommendationIcon" />
                        <span className="margin-left-5"> {InsightsStrings.recommendation}</span>
                      </div>
                      <h4>{item?.recommendation}</h4>
                    </div>
                  )}
                </div>
              ))}
            </div>
            <div className="margin-top-10">
              {FoulingTypes.optional}
              {FoulingTypes.optionalDescription}
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
};

export default FoulingType;
